import { first, join, map } from 'lodash';
import React from 'react';
import useCellRulePanels from 'utils/queryHooks/cellRule/useCellRulePanels';
import { CellRulesPanel, CellRulesPanelSkeleton } from './CellRulesPanel';

export const GLOBAL_PANEL_STUDY_ID = 'global';

interface GlobalCellRulesPanelProps {
  editable?: boolean;
}

export const GlobalCellRulesPanel: React.FC<GlobalCellRulesPanelProps> = ({ editable = false } = {}) => {
  const { data: panels, isLoading: isLoadingPanels } = useCellRulePanels(GLOBAL_PANEL_STUDY_ID);

  if (panels && panels.length > 1) {
    console.warn(
      `More than one global panel found, panel ids: ${join(map(panels, 'id'), ',')}. taking the first one: ${
        first(panels)?.id
      }`
    );
  }
  const globalPanelId = first(panels)?.id;

  return isLoadingPanels ? (
    <CellRulesPanelSkeleton />
  ) : (
    <CellRulesPanel studyId={GLOBAL_PANEL_STUDY_ID} panelId={globalPanelId} editable={editable} />
  );
};
